import { useIntl } from "react-intl";
import { useGenerateReport } from "~pages/Reports/hooks/useGenerateReport.ts";
import "./GenerateReportButton.scss";
import { Space, Typography } from "antd";

type Props = {
  titleIntlKey: string;
  descriptionIntlKey: string;
  url: string;
  notificationMessageIntlKey: string;
};
export const GenerateReportButton = ({ url, notificationMessageIntlKey, titleIntlKey, descriptionIntlKey }: Props) => {
  const { mutate: generateReport } = useGenerateReport();
  const { formatMessage } = useIntl();

  return (
    <div
      className="report-button"
      onClick={() =>
        generateReport({
          url,
          notificationMessage: formatMessage({ id: notificationMessageIntlKey }),
        })
      }
    >
      <Space direction={"vertical"} size={6}>
        <Space>
          <i className="fas fa-file-arrow-down"></i>
          <Typography.Title level={4} className="report-button-title">
            {formatMessage({ id: titleIntlKey })}
          </Typography.Title>
        </Space>
        <Typography style={{ fontSize: 12 }}>{formatMessage({ id: descriptionIntlKey })}</Typography>
      </Space>
    </div>
  );
};
